// Services
import AuthService from './AuthService';
import LodashService from './LodashService';
import ToastService from './ToastService';
import SocketService from './SocketService';

angular
	.module('app.services', [
		'btford.socket-io'
	])
	.service('AuthService', AuthService)
	.service('_', LodashService)
	.service('ToastService', ToastService)
	.factory('socket', SocketService);
